import axios from "axios";
import Config from "./../../config/index";
import RefreshTokenHandler from "./refresh-token";

const addProvidentFundsBulkUploader = async (
  email: string,
  company_code: string,
  data: any,
  txn_obj: any
) => {
  const url = `${Config.baseUrl}/provident/bulk-upload-provident-fund`;
  try {
    let result: any = await axios.post(
      url,
      {
        email,
        company_code,
        txn_to_create: txn_obj,
        data,
      },
      {
        headers: {
          Authorization: sessionStorage.getItem("token") || "",
        },
      }
    );
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await addProvidentFundsBulkUploader(
          email,
          company_code,
          data,
          txn_obj
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const addLoanApplication = async (
  email: string,
  company_code: string,
  symbol_code: string,
  fund_name: string,
  folio_no: string,
  employee_name: string,
  loan_amount: number,
  number_of_installment: number,
  remaining_loan: number,
  total_loan_applicable: number,
  employee_loan_amount_percentage: number,
  employer_loan_amount_percentage: number,
  loan_refundable?: boolean,
  amount_per_installement?: number,
  txn_to_create?: any
) => {
  const url = `${Config.baseUrl}/provident/add-loan-application`;
  try {
    let result: any = await axios.post(
      url,
      {
        email,
        company_code,
        symbol_code,
        fund_name,
        folio_no,
        employee_name,
        loan_amount,
        number_of_installment,
        remaining_loan,
        total_loan_applicable,
        employee_loan_amount_percentage,
        employer_loan_amount_percentage,
        loan_refundable,
        amount_per_installement,
        txn_to_create,
      },
      {
        headers: {
          Authorization: sessionStorage.getItem("token") || "",
        },
      }
    );
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await addLoanApplication(
          email,
          company_code,
          symbol_code,
          fund_name,
          folio_no,
          employee_name,
          loan_amount,
          number_of_installment,
          remaining_loan,
          total_loan_applicable,
          employee_loan_amount_percentage,
          employer_loan_amount_percentage,
          loan_refundable,
          amount_per_installement,
          txn_to_create
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

/***
 * @param email
 */
const getAllProvidentFunds = async (
  email: string,
  amc_code: string,
  symbol_code: string = "",
  folio_no: string = "",
  to_date: string = "",
  from_date: string = "",
  employee_name: string = "",
  flatten = "false",
  loan_fetch = "false"
) => {
  const url = `${Config.baseUrl}/provident?email=${email}&amc_code=${amc_code}&symbol_code=${symbol_code}&folio_no=${folio_no}&to_date=${to_date}&from_date=${from_date}&employee_name=${employee_name}`;
  try {
    let result: any = await axios.get(url, {
      params: { flatten, loan_fetch },
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getAllProvidentFunds(
          email,
          amc_code,
          symbol_code,
          folio_no,
          to_date,
          from_date,
          employee_name,
          flatten
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

/***
 * @param email
 */
const getAllLoanApplications = async (
  email: string,
  amc_code: string,
  symbol_code?: string,
  folio_no?: string,
  loan_status?: string
) => {
  const url = `${Config.baseUrl}/provident/get-loan-application?email=${email}&amc_code=${amc_code}&symbol_code=${symbol_code}&folio_no=${folio_no}&loan_status=${loan_status}`;
  try {
    let result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getAllLoanApplications(
          email,
          amc_code,
          symbol_code,
          folio_no,
          loan_status
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const updateLoanApplicationStatus = async (
  loanId: string,
  email: string,
  loan_status: string
) => {
  const url = `${Config.baseUrl}/provident/loan-applications/${loanId}/status`;
  try {
    let result: any = await axios.put(
      url,
      {
        email: email,
        loan_status: loan_status,
      },
      {
        headers: {
          Authorization: sessionStorage.getItem("token") || "",
        },
      }
    );
    return result;
  } catch (err: any) {
    if (err.response?.data?.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await updateLoanApplicationStatus(loanId, email, loan_status);
      } else {
        throw err;
      }
    } else {
      throw err;
    }
  }
};

/***
 * @param email
 */
const getAllProvidentFundsByFolioAndFund = async (
  email: string,
  amc_code: string,
  symbol_code: string,
  folio_no: string
) => {
  const url = `${Config.baseUrl}/provident/provident-by-fund-and-folio?email=${email}&amc_code=${amc_code}&symbol_code=${symbol_code}&folio_no=${folio_no}`;
  try {
    let result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getAllProvidentFundsByFolioAndFund(
          email,
          amc_code,
          symbol_code,
          folio_no
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const getProvidentFundProfitSummary = async (
  email: string,
  amc_code: string,
  symbol_code: string = "",
  folio_no: string = "",
  to_date: string = "",
  from_date: string = "",
  employee_name: string = "",
  flatten = "false",
  loan_fetch = "false"
) => {
  const url = `${Config.baseUrl}/provident/profit-summary?email=${email}&amc_code=${amc_code}&symbol_code=${symbol_code}&folio_no=${folio_no}&to_date=${to_date}&from_date=${from_date}&employee_name=${employee_name}`;
  try {
    let result: any = await axios.get(url, {
      params: { flatten, loan_fetch },
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getAllProvidentFunds(
          email,
          amc_code,
          symbol_code,
          folio_no,
          to_date,
          from_date,
          employee_name,
          flatten
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

export {
  addProvidentFundsBulkUploader,
  getAllProvidentFunds,
  getAllProvidentFundsByFolioAndFund,
  addLoanApplication,
  getAllLoanApplications,
  updateLoanApplicationStatus,
  getProvidentFundProfitSummary,
};
